<template>
  <div>
    <el-card class="box-card">
      <div class="title mt20">领用出库</div>
      <el-form :model="addForm" ref="addFormRef" label-width="100px">
        <el-form-item label="类别" class="addAdminForm">
          <el-input v-model="addForm.leibie" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="名称" class="addAdminForm">
          <el-input v-model="addForm.name" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="规格/型号" class="addAdminForm">
          <el-input v-model="addForm.guige" placeholder="" disabled></el-input>
        </el-form-item>
        <el-form-item label="领用日期" class="addAdminForm">
          <el-date-picker v-model="addForm.lingyongriqi" type="date" placeholder="领用日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="领用人" class="addAdminForm">
          <el-input v-model="addForm.lingyongren" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="领用数量" class="addAdminForm">
          <el-input v-model="addForm.num" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="用途" class="addAdminForm">
          <el-input v-model="addForm.yongtu" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="备注" class="addAdminForm">
          <el-input v-model="addForm.beizhu" placeholder=""></el-input>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>

      <div class="title mt20">领用出库记录</div>
      <el-table :data="dataList" border stripe class="mt15">
        <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
        <el-table-column prop="Lingyongriqi" label="领用日期" min-width="10%"></el-table-column>
        <el-table-column prop="Lingyongren" label="领用人" min-width="10%"></el-table-column>
        <el-table-column prop="Leibie" label="类别" min-width="10%"></el-table-column>
        <el-table-column prop="Name" label="名称" min-width="10%"></el-table-column>
        <el-table-column prop="Guige" label="规格/型号" min-width="10%"></el-table-column>
        <el-table-column prop="Num" label="数量" min-width="10%"></el-table-column>
        <el-table-column prop="Yongtu" label="用途" min-width="10%"></el-table-column>
        <el-table-column prop="Beizhu" label="备注" min-width="10%"></el-table-column>
        <el-table-column prop="Createusername" label="操作人" min-width="10%"></el-table-column>
        <el-table-column prop="CreateTime" label="操作时间" min-width="15%"></el-table-column>
        <el-table-column prop="operation" label="操作" min-width="10%" v-if="SubRule_MenDianPurchaseSalesKuCunOutUse_Delete">
          <template v-slot="scope">
            <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      addForm: {
        jigouid: '-1',
        lingyongriqi: '',
        lingyongren: '',
        leibie: '',
        name: '',
        guige: '',
        num: '',
        yongtu: '',
        beizhu: ''
      },
      dataList: [],
      SubRule_MenDianPurchaseSalesKuCunOutUse_Delete: false
    }
  },
  methods: {
    LoadData (row) {
      this.addForm.jigouid = row.Jigouid
      this.addForm.leibie = row.Leibie
      this.addForm.name = row.Name
      this.addForm.guige = row.Guige
      this.apiGetMenDianPurchaseSalesKuCunOutUseList()

      var that = this
      Vue.prototype.FunCheckSubRule('SubRule_MenDianPurchaseSalesKuCunOutUse_Delete', function (response) {
        if (response.data.Code === 200) {
          that.SubRule_MenDianPurchaseSalesKuCunOutUse_Delete = true
        }
      })
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiAddMenDianPurchaseSalesKuCunOutUse()
    },
    clickDelete (row) {
      this.$confirm('是否删除此领用出库记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteMenDianPurchaseSalesKuCunOutUse(row.Id)
      })
    },
    apiAddMenDianPurchaseSalesKuCunOutUse: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: this.addForm.jigouid,
        lingyongriqi: this.addForm.lingyongriqi,
        lingyongren: this.addForm.lingyongren,
        leibie: this.addForm.leibie,
        name: this.addForm.name,
        guige: this.addForm.guige,
        num: this.addForm.num,
        yongtu: this.addForm.yongtu,
        beizhu: this.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMenDianPurchaseSalesKuCunOutUse, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetMenDianPurchaseSalesKuCunOutUseList()
            that.addForm.lingyongriqi = ''
            that.addForm.lingyongren = ''
            that.addForm.num = ''
            that.addForm.yongtu = ''
            that.addForm.beizhu = ''
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetMenDianPurchaseSalesKuCunOutUseList: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: this.addForm.jigouid,
        name: this.addForm.name,
        guige: this.addForm.guige
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMenDianPurchaseSalesKuCunOutUseList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DeleteMenDianPurchaseSalesKuCunOutUse: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteMenDianPurchaseSalesKuCunOutUse, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetMenDianPurchaseSalesKuCunOutUseList()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
.productdata1 {
  padding-bottom: 20px;
}

.productdata2 {
  padding-bottom: 5px;
}
</style>
